import Modal from "../Modal";
import CompanyBranchNewForm from "../../forms/company/CompanyBranchNewForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function CompanyBranchNewModal({show, handleClose, company_id, callback, title = null}) {
    const { t } = useTranslation();
    const defaultTitle = t("companyBranch.new");
    return (
        <Modal title={title || defaultTitle} show={show} handleClose={handleClose}>
            <CompanyBranchNewForm handleClose={handleClose} company_id={company_id} callback={callback} />
        </Modal>
    );
};